import { Profile } from './profile.model';
import { Interest, InterestCategory } from './interest.model';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '../modules/crud';

export interface AffinityProfile { profile: Profile, flashDate: number };
export interface AffinityCategory { category: InterestCategory, inCommon: number };

@CwtModel({ name: 'affinity', path: '/affinity' })
export class Affinity extends ApiData {
    profiles: [AffinityProfile, AffinityProfile];
    globalAffinity: number;
    languageAffinity: number;
    campingTypeAffinity: number;
    ageAffinity: number;
    criteriasAffinity: number;
    perCategoryAffinity: AffinityCategory[];
    interestsInCommon: Interest[];
    katchInCommon: Profile[];
    katchDate: number;
    isFlash: boolean;
    isKatch: boolean;
    flashedYou: boolean;
    isBlocked: boolean;
}


export enum AffinityStatus {
    Default = 'default',
    FlashedMe = 'flashed-me',
    FlashedThem = 'flashed-them',
    Katched = 'katched',
    Blocked = 'blocked'
}